import CONFIG from "../config"
var TimeAuction = {};
TimeAuction.clock = {};
TimeAuction.clockController = {};
TimeAuction.clockController.dsClock = {}

TimeAuction.data = {
  'clock': null,
  "then": null,
  "serverTime": null,
  "responseTime": null,
  "RThalf": null,
  "realTimeDif": null,
  "requestTime": null,
  "leapsecond": null,
  "dststart": null,
  "dstend": null,
  "currYear": null,
  "dstDates": null,
  "leapDate": null,
  "clockinstances": [],
  "leapFlag": null,
  "leapsec60": null,
  "myhour0": "0",
  "myhour1": "0",
  "mysec0": "0",
  "mysec1": "0",
  "currentTime": null,
}


TimeAuction.clockController.getleapdate = function() {
  var leap = new Date();
  var temp1 = TimeAuction.data.leapdate.split(" ");
  var leapdateYear = temp1[0];
  var leapdateMonth = temp1[1];

  leapdateMonth = leapdateMonth - 1; 

  var leapdateDay = temp1[2];

  leap.setUTCFullYear(leapdateYear, leapdateMonth, leapdateDay);
  leap.setUTCHours(0, 0, 0, 0);

  TimeAuction.data.leapsecond = leap.getTime();
}

TimeAuction.clockController.dsClock.doRequest =  function() {
  let d = new Date();
  var xmlHttp = new XMLHttpRequest();

  xmlHttp.open("GET", CONFIG.API_URL + "/api/Systems/Clock?ct=" + d.getTime(), false);
  xmlHttp.send(null);
  return xmlHttp.responseText;
}

TimeAuction.clockController.checkservertime = function() {
  var o = new Object();
  var d = new Date();
  var currentTimeObj = new Date();
  TimeAuction.data.requestTime = currentTimeObj.getTime();
  TimeAuction.data.currentTime = TimeAuction.clockController.dsClock.doRequest();  
  TimeAuction.clockController.doData();
}

 TimeAuction.clockController.doAuxData = function() {
  parser = new DOMParser();
  xmlDoc = parser.parseFromString(TimeAuction.auxdata, "text/xml");
  TimeAuction.data.curryear = xmlDoc.getElementsByTagName("currYear")[0].childNodes[0].nodeValue;
  TimeAuction.data.dstdates = xmlDoc.getElementsByTagName("DstDates")[0].childNodes[0].nodeValue;
  TimeAuction.data.leapdate = xmlDoc.getElementsByTagName("LeapDate")[0].childNodes[0].nodeValue;
}

TimeAuction.clockController.getDSTdates = function() {
  var dstStartDate = new Date();
  var dstEndDate = new Date();
  var temp=TimeAuction.data.dstdates.split(" "); 
  var startmonth = temp[0];

  startmonth = startmonth - 1; 

  var startday = temp[1];
  var endmonth = temp[2];

  endmonth = endmonth - 1;

  var endday = temp[3];

  dstStartDate.setUTCFullYear(TimeAuction.data.curryear, startmonth, startday);
  dstStartDate.setUTCHours(2, 0, 0, 0);
  dstEndDate.setUTCFullYear(TimeAuction.data.curryear, endmonth, endday);
  dstEndDate.setUTCHours(1, 0, 0, 0);
  TimeAuction.data.dstStart = dstStartDate.getTime();
  TimeAuction.data.dstEnd = dstEndDate.getTime();

}

TimeAuction.clockController.auxdata = function() {
  this.doAuxData();
  this.getDSTdates();
  this.getleapdate();
}

TimeAuction.clockController.doData = function() {
    
  var parser = new DOMParser();
  var xmlDoc = parser.parseFromString(TimeAuction.data.currentTime, "text/xml");

  var t2 = xmlDoc.getElementsByTagName("timestamp")[0].getAttribute("time2");
  var t3 = xmlDoc.getElementsByTagName("timestamp")[0].getAttribute("time3");
  var serverDelay = Math.round((t3 - t2) / 1000); 

  TimeAuction.data.serverTime = Math.round(t3/1000);  

  var currentTimeObj2 = new Date();
  TimeAuction.data.responseTime = currentTimeObj2.getTime(); 
  TimeAuction.data.RThalf = ((TimeAuction.data.responseTime - TimeAuction.data.requestTime) - serverDelay) / 2; 
  TimeAuction.data.realTimeDif = TimeAuction.data.serverTime - TimeAuction.data.responseTime; 


  TimeAuction.clockController.runningclocks();
  TimeAuction.data.leapFlag = "false";
} 

TimeAuction.clockController.runningclocks = function(show) {
  var deviceClock = new Date();
  var fractionalZone =(Math.abs((deviceClock.getTimezoneOffset()/60))) % 1;   
  if (fractionalZone != 0) {
    fractionalZone = (1 - fractionalZone);                                   
    }
  
  var fractionalZoneMilli = fractionalZone * 3600000;                        
 
  var s = new Date();
  s.setTime(s.getTime() + TimeAuction.data.realTimeDif + TimeAuction.data.RThalf - fractionalZoneMilli); 

  var sec = s.getSeconds();
  if (sec != TimeAuction.data.previousSec) { 
    TimeAuction.data.previousSec = sec;
    return TimeAuction.clockController.handleonrefresh(s, show);
  }
}

TimeAuction.clockController.handleonrefresh = function(s, show) {
  var now = s.getTime(); 
  if (TimeAuction.data.then == null) {
    TimeAuction.data.then = now;      
  }

  var DidUserChangeClock = Math.abs(now - TimeAuction.data.then);
  if (DidUserChangeClock >= 2000) { 
        // location.reload();
        TimeAuction.data.then = now;
   } else {
        TimeAuction.data.then = now;
  }

  if (TimeAuction.data.leapsecond / 1000 == Math.floor(now / 1000)) {
    TimeAuction.data.leapFlag = "true"
  }

  return TimeAuction.clock.setCurrentTime(show, now, true, TimeAuction.data.dstStart, TimeAuction.data.dstEnd, -7, TimeAuction.data.leapFlag, TimeAuction.data.leapsec60, TimeAuction.data.RThalf, 999); 
}  

TimeAuction.clock.setCurrentTime = function(show, now, twentyFour, dstStart, dstEnd, zoneOffset, leapFlag, leapsec60, RThalf, clockNum) {
    var displayTime = new Date();
    displayTime.setTime(now);
    
    var date = displayTime.getDate();
    if (date<10) {
      date = "0"+date;
    }
    var day = displayTime.getDay();
    var month = displayTime.getMonth() + 1;
    if (date<10) {
      month = "0"+month;
    }
    var year = displayTime.getFullYear();

    now = (now + (7 * 3600000 ));

    if (leapFlag == "true"){
       now = now - 1000; 
       var leapsec60 = "true"; 
    }

    displayTime.setTime(now);

    var hourNum = displayTime.getUTCHours();
    var minNum = displayTime.getMinutes();
    var secNum = displayTime.getSeconds();

  if (hourNum > 23) {
    hourNum = 0;
    now = (now + 3600000)
      displayTime.setTime(now); 
  }
  
  if (leapFlag == "true") {
    if (leapsec60 == "true") {
      if (minNum == "59") {
        if (secNum == "59") { 
          secNum = "60";
          leapsec60 = "false";
        }
      }
    }
  }
  
  TimeAuction.data.clock = now;
  if (!show){
    return now;
  }

  var newVal;
  if(hourNum > 9) {
    newVal = Number(String(hourNum).charAt(0));
    if(TimeAuction.data.myhour0 != newVal) {
      TimeAuction.data.myhour0 = newVal;
    }
  }
  else if(Number(TimeAuction.data.myhour0) != 0) {
    TimeAuction.data.myhour0 = "0";
  }

  if(Number(hourNum) > 9){
    newVal=Number(String(hourNum).charAt(1));
    if(TimeAuction.data.myhour1 != newVal) {
      TimeAuction.data.myhour1 = newVal;
    }
  } else if (Number(TimeAuction.data.myhour1) != Number(hourNum)) {
    TimeAuction.data.myhour1 = Number(hourNum);
  }

  if  ((hourNum < 1) && (!(twentyFour))) {
    TimeAuction.data.myhour0 = 1;
    TimeAuction.data.myhour1 = 2;
  }

  if(minNum > 9) {
    newVal = Number(String(minNum).charAt(0));
    if (TimeAuction.data.mymin0 != newVal) {
      TimeAuction.data.mymin0 = newVal;
    }
  } else if(Number(TimeAuction.data.mymin0) != 0) {
    TimeAuction.data.mymin0 = 0;
  }

  if(Number(minNum) > 9) {
    newVal = Number(String(minNum).charAt(1));
    if(TimeAuction.data.mymin1 != newVal) {
      TimeAuction.data.mymin1 = newVal;
    }
  }
  else if(Number(TimeAuction.data.mymin1) != Number(minNum)) {
    TimeAuction.data.mymin1 = Number(minNum);
  }

  if(secNum > 9) {
    newVal = Number(String(secNum).charAt(0));
    if(TimeAuction.data.mysec0 != newVal) {
      TimeAuction.data.mysec0 = newVal;
    }
  }
  else if(Number(TimeAuction.data.mysec0) != 0) {
    TimeAuction.data.mysec0 = 0;
  }

  if(Number(secNum) > 9) {
    newVal=Number(String(secNum).charAt(1));
    if(TimeAuction.data.mysec1 != newVal) {
      TimeAuction.data.mysec1 = newVal;
    }
  }
  else if(Number(TimeAuction.data.mysec1) != Number(secNum)) {
    TimeAuction.data.mysec1 = Number(secNum);
  }

  var day_name = '';
    switch (day) {
    case 0:
        day_name = "Chủ nhật";
        break;
    case 1:
        day_name = "Thứ hai";
        break;
    case 2:
        day_name = "Thứ ba";
        break;
    case 3:
        day_name = "Thứ tư";
        break;
    case 4:
        day_name = "Thứ năm";
        break;
    case 5:
        day_name = "Thứ sáu";
        break;
    case 6:
        day_name = "Thứ bảy";
    }
  var clockdigits = (TimeAuction.data.myhour0 + "" + TimeAuction.data.myhour1 + ":" + TimeAuction.data.mymin0 + TimeAuction.data.mymin1 + ":" + TimeAuction.data.mysec0 + TimeAuction.data.mysec1);
  var clock = clockdigits
  var date_info = day_name+', '+date+'/'+month+'/'+year
  let date_str = clock + ' ' + date_info;
  return { "now": date_str, "timestamp": now};

}

export default TimeAuction;


// WEBPACK FOOTER //
// ./src/common/api/time.js